import {Component, Input, OnInit} from '@angular/core';
import {Project} from '../../../../core/models';
import {MatchInfo} from '../../../../core/models/match';
import * as moment from 'moment';
import {ConfigService} from '../../../../core/services/config.service';

@Component({
  selector: 'app-project-activity-match-summary',
  templateUrl: './activity-match-summary.html'
})
export class ActivityMatchSummaryComponent implements OnInit {
  @Input() matchInfo: MatchInfo;
  @Input() project: Project;

  constructor() {
  }

  ngOnInit() {
    this.matchInfo.matchLink = ['/project', this.project.id, 'activity', 'match', this.matchInfo.matchId];
  }

  getBranchId() {
    return this.project.projectBranches.filter(branch => branch.name === this.matchInfo.branchName)[0].id;
  }

  getMatchSince() {
    const start = moment(this.matchInfo.startTime);
    const end = moment();

    if (start) {
      const duration = end.unix() - moment(start).unix();

      let diff = '';

      if (moment.duration(duration, 'seconds').years() !== 0) {
        diff += moment.duration(duration, 'seconds').years() + ' years';
      } else if (moment.duration(duration, 'seconds').months() !== 0) {
        diff += moment.duration(duration, 'seconds').months() + ' months';
      } else if (moment.duration(duration, 'seconds').days() !== 0) {
        diff += moment.duration(duration, 'seconds').days() + ' days';
      } else if (moment.duration(duration, 'seconds').hours() !== 0) {
        diff += moment.duration(duration, 'seconds').hours() + ' hours';
      } else {
        diff += moment.duration(duration, 'seconds').minutes() + ' minutes';
      }

      return diff;

    } else {
      '';
    }

  }

  getTooltip() {
    return 'Start on ' + moment(this.matchInfo.startTime).format(ConfigService.timeFormatMatch)
      + (this.matchInfo.endTime != null ? '\nEnded on ' + moment(this.matchInfo.endTime).format(ConfigService.timeFormatMatch)
        : '');
  }

  getHumanReadablePlayerString() {
    if (this.matchInfo.playerCount == 1) {
      return 'player';
    } else {
      return 'players';
    }
  }

  getHumanReadableStatusString() {
    switch (this.matchInfo.status) {
      case 'IN_PROGRESS':
        return 'is in progress';
      case 'COMPLETED':
        return 'completed';
      case 'TIMED_OUT':
        return 'timed out';
      default:
        return 'is in an unknown state';
    }
  }
}

